import React, { useState } from 'react'
import { graphql, useStaticQuery, Link, navigate} from "gatsby";
import MiniSearch from 'minisearch'
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export default function Search () {
    const query= useStaticQuery(graphql`
        query allProductsSeraching($limit: Int, $skip: Int) {
            allMdx(
            sort: {frontmatter: {date: DESC}}
            skip: $skip
            limit: $limit
            filter: { frontmatter:{ inventory: { nin:[ 0, null ] } }, fields: {slug: {ne: "/slider/slider/"}}} 
            ) {
                nodes {
                    id
                    frontmatter {
                        title
                        code    
                    }
                    fields {
                        slug
                    }
                    HeaderImage {
                        childImageSharp {
                            gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
                        }
                    }
                }
            }
        }
    `)
    
    const [searchResults, setSearchResults] = useState([])
    const [searchText, setSearchText] = useState("")
    const [visible, setVisible] = useState(false)

    const { nodes }= query.allMdx
    
    const main = document.querySelectorAll('main > div')
    
    const headerAncor = document.querySelectorAll('main > a')

    const footer = document.querySelectorAll('footer > div')
        
    const miniSearch = new MiniSearch({
        fields: ['title', 'code'], // fields to index for full-text search
        storeFields: ['title', 'code', 'slug', 'id', 'HeaderImage' ] // fields to return with search results
    })
    const formattedDocuments = nodes.map(({ frontmatter: { title, code }, fields:{ slug }, id, HeaderImage }) => ({ id ,slug ,title, code, HeaderImage }))

    miniSearch.addAll(formattedDocuments)

    const onChange = (e) =>{
        const word = e.target.value
        
        const results = miniSearch.search(word)

        setSearchText(word)

        setSearchResults(results)
        
        setVisible(true)
    }
    const handleClickOnLink= () => {
        setSearchText("")
        setSearchResults([])
    }   
    const onHandleSubmit= (e) => {
        e.preventDefault()
        
        if(setSearchResults.length===0) return;
        
        const node= searchResults[0]
        
        const { id, fields } = node

        const slug= fields.slug.split("/",2).at(1)
        
        const inputLink= `/products/${slug}/${id}`
        
        navigate(inputLink)
        setSearchText("")
        setSearchResults([])

    }
    const clickEvent = (event) => {
        event.preventDefault()
        setVisible(false)
        return
    }
    const addClickEventToElements = (elements) => {
        if(elements.length > 0){
            for(const element of elements)
                element.addEventListener('click', clickEvent, false)
        }
    }
    addClickEventToElements(headerAncor)
    addClickEventToElements(main)
    addClickEventToElements(footer)

    return (
        <div className='w-full text-black relative'>
            <form onSubmit={onHandleSubmit}>
                <input
                    id="Search"
                    className="flex self-center pl-2 bg-transparent w-full mx-1/5 "
                    type="search"
                    value={searchText}
                    placeholder="Search"
                    onChange={onChange}
                    onClick={()=> setVisible(true)} 
                    onKeyDown={()=>setVisible(true)}
                />
            </form>
            <div className='absolute z-50 bg-white max-h-80 md:max-h-56 overflow-auto'>
                {
                    searchResults && visible &&
                        searchResults.map(({ id, title, code, slug: slugWithoutFormat, HeaderImage })=>{
                                                        
                            const slug = slugWithoutFormat.split("/",2).at(1)                        
                            
                            const selected = searchResults.find(element=>element.id === id)
                            
                            const image = getImage(HeaderImage)

                            return (
                                <Link
                                    key={`searchItem ${id}`}
                                    to={`/products/${slug}/${id}`}
                                    className={`flex w-full my-2 ${selected? "flex" : "hidden"}`}

                                >
                                    <button className="flex border w-full mx-1" onClick={handleClickOnLink}>
                                        <div className="flex w-24 h-20">
                                            <GatsbyImage
                                                alt={title}
                                                image={image}
                                                className='w-24 h-20'
                                            />
                                        </div>
                                        <div className="flex flex-col text-xs w-full justify-center h-full pl-10">
                                            <h1 className="flex font-bold justify-start">{title}</h1>
                                            <p className="flex justify-start">Código: {code}</p>
                                        </div>
                                    </button>
                                </Link>
                            )
                        })
                }
            </div>
        </div>
    )
}
